import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-player-achievements',
  templateUrl: './player-achievements.component.html',
  styleUrls: ['./player-achievements.component.scss']
})
export class PlayerAchievementsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
